import {
  Alert,
  Container,
  Header,
  SpaceBetween,
  Spinner,
  StatusIndicator,
} from '@cloudscape-design/components';
import ScanField from 'features/scan/components/ScanField';
import { ScanTypes } from 'features/scan/utils/parseScanCode';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Traveler scan input plus the load status / prefill warnings.
 * Reports a parsed traveler id via onTravelerId.
 */
export default function TravelerScanSection({
  travelerId = null,
  loading = false,
  loadError = null,
  warnings = [],
  loaded = false,
  onTravelerId,
}) {
  return (
    <Container header={<Header variant="h2">Traveler</Header>}>
      <SpaceBetween size="m">
        <ScanField
          id="print-product-label-scan"
          accept={[ScanTypes.TRAVELER]}
          onScan={({ id }) => onTravelerId(id)}
          label="Traveler"
          description="Scan a traveler QR code, or paste a traveler ID / URL and press Enter, to prefill the label."
          autoFocus
          closeOnScan
        />

        {loading && <Spinner />}
        {loadError && (
          <Alert type="error" header="Failed to load traveler">{loadError}</Alert>
        )}
        {!loading && !loadError && loaded && (
          <StatusIndicator type="success">
            {`Loaded traveler ${travelerId}`}
          </StatusIndicator>
        )}
        {!loading && warnings.length > 0 && (
          <Alert type="warning" header="Some label fields could not be prefilled">
            <ul style={{ margin: 0, paddingLeft: 16 }}>
              {warnings.map((warning) => <li key={warning}>{warning}</li>)}
            </ul>
          </Alert>
        )}
      </SpaceBetween>
    </Container>
  );
}

TravelerScanSection.propTypes = {
  travelerId: PropTypes.string,
  loading: PropTypes.bool,
  loadError: PropTypes.string,
  warnings: PropTypes.arrayOf(PropTypes.string),
  loaded: PropTypes.bool,
  onTravelerId: PropTypes.func.isRequired,
};
